/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Reinvited_DescInputs */



/**
* | output |
* | --- |
* | "The invitation email was sent again. The new link replaces the earlier one and expires 24 hours after this point." |
*
* @param {Audit_Details_Member_Reinvited_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_reinvited_desc = /** @type {((inputs?: Audit_Details_Member_Reinvited_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Reinvited_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Einladungs-E-Mail wurde erneut gesendet. Der neue Link ersetzt den vorherigen und läuft 24 Stunden nach diesem Zeitpunkt ab.")
	return /** @type {LocalizedString} */ ("The invitation email was sent again. The new link replaces the earlier one and expires 24 hours after this point.")
});